import { Fragment, ReactNode } from 'react';

import { useIsMobile } from '../../hooks';
import SkeletonLoaderRow from '../WatchList/WatchListTable/SkeletonLoaderRow/SkeletonLoaderRow';

import styles from './SymbolTable.module.scss';

type Props<T> = {
  id?: string;
  isWithMobileHeaders?: boolean;
  isLoading?: boolean;
  items: T[];
  renderHeaders?: () => ReactNode;
  renderRow: (item: T, index: number) => ReactNode;
  skeletonCount?: number;
  rowItemsCount?: number;
  skeletonGrid?: string;
};

const SymbolTable = <T, >({
  id,
  isLoading,
  items,
  isWithMobileHeaders,
  renderHeaders,
  renderRow,
  skeletonCount = 10,
  rowItemsCount,
  skeletonGrid,
}: Props<T>) => {
  const { isMobile } = useIsMobile();

  if (isMobile) {
    if (isLoading) {
      return (
        <>
          {Array.from({ length: skeletonCount }).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <SkeletonLoaderRow key={index.toString()} />
          ))}
        </>
      );
    }

    return (
      <>
        {isWithMobileHeaders
          && renderHeaders?.()}

        {items.map((item, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Fragment key={index.toString()}>{renderRow(item, index)}</Fragment>
        ))}
      </>
    );
  }

  return (
    <div id={id} className={styles.table}>
      {renderHeaders?.()}

      {isLoading ? (
        <>
          {Array.from({ length: skeletonCount }).map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <SkeletonLoaderRow key={index.toString()} rowItemsCount={rowItemsCount} skeletonGrid={skeletonGrid} />
          ))}
        </>
      ) : (
        <div className={styles.rowWrapper}>
          {items.map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Fragment key={index.toString()}>{renderRow(item, index)}</Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

export default SymbolTable;
